import { render, staticRenderFns } from "./LabelAngleIcon.vue?vue&type=template&id=db78a9ea&"
import script from "./LabelAngleIcon.vue?vue&type=script&lang=js&"
export * from "./LabelAngleIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports